// The FreshOrder iOS app's App Store id (io.freshorder.app). One place for the
// sign-in card's badge and the Safari Smart App Banner the server injects.
export const APP_STORE_APP_ID = "6808185332";
